import { render } from "./LegacySubscription.vue?vue&type=template&id=0517d7a3"
import script from "./LegacySubscription.vue?vue&type=script&lang=js"
export * from "./LegacySubscription.vue?vue&type=script&lang=js"

import "./LegacySubscription.vue?vue&type=style&index=0&id=0517d7a3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__